import { Button, Dialog } from "@mui/material";
import { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import Select from 'react-select'
import { getTheCheckAdditionalCharges } from "../../utils/summaryCalculation";
import { useTheme } from "../hooks/useTheme";
import colorConfigs from "../../configs/colorConfigs";
import { addNewAdditionalCharge } from "../../services/rental";
import Cookies from "js-cookie";
import useTenant from "../hooks/useTenant";

type AddAdjustmentModalProps = {
    adjustmentIsOpen: boolean;
    setAdjustmentIsOpen: (value: boolean) => void;
    extraValue: any[];
    isCompletedOrCancelled: boolean;
    getDataFromExtras: (extraValue: any[]) => void;
    refreshTheSummary: () => void;
    reservationId: number;
    setPleaseWait: (value: boolean) => void;
}

const AddAdjustmentModal = ({
    adjustmentIsOpen,
    setAdjustmentIsOpen,
    extraValue,
    isCompletedOrCancelled,
    getDataFromExtras,
    refreshTheSummary,
    reservationId,
    setPleaseWait
}: AddAdjustmentModalProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { theme, themeStyles } = useTheme();
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const [selctedAdjusment, setSelectedAdjustment] = useState<number>(0);
    const [adjustmentOptions, setAdjustmentOptions] = useState<any[]>([]);
    const [selectionType, setSelectionType] = useState<string>("");
    const [selectedCategoryId, setSelectedCategoryId] = useState<number>(0);
    const [price, setPrice] = useState<string>('');
    const [comment, setComment] = useState<string>("");
    const [selectedChargeType, setSelectedChargeType] = useState<string>("Amount");
    const closeIconFill = theme === "dark" ? "fill-[#E4E7EC]" : "fill-[#1D2939]";


    useEffect(() => {
        const updatedAdjustmentValue = extraValue?.map((item: any) => {
            const additionalCharges = item?.additionalCharges
                ?.filter((value: any) => !value.hideFromReservations && value?.reservationAdditionalId === 0)
                ?.map((value: any) => {

                    return {
                        ...value,
                        value: value?.id,
                        label: value?.name,
                        categoryId: item?.id,
                        quantity: value?.quantity ?? 1,
                        basePrice: value?.basePrice ?? 0,
                        isChecked: value?.isChecked ?? false,
                        reservationAdditionalId: value?.reservationAdditionalId ?? 0
                    }
                });

            return {
                label: item?.categoryName,
                options: additionalCharges
            };
        });

        setAdjustmentOptions(updatedAdjustmentValue);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [extraValue])

    useEffect(() => {
        if (selctedAdjusment > 0) {
            const selectedAdjustmentAdditionalCharge = adjustmentOptions?.find((item: any) =>
                item?.options?.some((data: any) => data?.value === selctedAdjusment)
            )?.options?.find((data: any) => data?.value === selctedAdjusment);

            if (selectedAdjustmentAdditionalCharge) {
                setSelectedCategoryId(selectedAdjustmentAdditionalCharge?.categoryId || 0);
                setPrice(selectedAdjustmentAdditionalCharge?.anountOrPercentage);
                setSelectionType(selectedAdjustmentAdditionalCharge?.selectionType);
                setSelectedChargeType(selectedAdjustmentAdditionalCharge?.chargeType);
            } else {
                // Handle case where no adjustment is found
                setSelectedCategoryId(0);
                setPrice('');
                setSelectionType('');
                setSelectedChargeType('');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selctedAdjusment])

    const resetForm = () => {
        setSelectedCategoryId(0);
        setPrice('');
        setSelectionType('');
        setSelectedChargeType('');
        setAdjustmentIsOpen(false);
        setComment("");
    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!isCompletedOrCancelled) {
            const updatedExtraData = await Promise.all(
                extraValue?.map(async (item: any) => {
                    if (item?.id !== selectedCategoryId) {
                        return item;
                    }

                    const additionalCharges = await Promise.all(
                        item?.additionalCharges?.map((value: any) => {
                            if (value?.id !== selctedAdjusment) {
                                return value;
                            }

                            addAdditionalCharge(value);

                            value = {
                                ...value,
                                isChecked: true
                            }

                            return value;
                        }));

                    return {
                        ...item,
                        additionalCharges
                    };
                }));

            getDataFromExtras(getTheCheckAdditionalCharges(updatedExtraData));
        }
    }


    const addAdditionalCharge = async (value: any) => {
        if (!isCompletedOrCancelled) {
            setPleaseWait(true);

            await addNewAdditionalCharge(
                reservationId,
                value?.additionalChargeBranchId,
                value?.id,
                Number(price),
                comment?.trim(),
                auth?.id,
                tenantId
            )
                .then(() => {
                    resetForm();
                    refreshTheSummary();
                    handleTenantError(null);
                })
                .catch((error => {
                    setPleaseWait(false);
                   handleTenantError(error);
                }))
        }
    };


    return (
        <>
            <Dialog
                open={adjustmentIsOpen}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '500px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[15px] py-[15px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320.591 320.591"
                        className={`w-3 cursor-pointer float-right ${closeIconFill}`}
                        onClick={() => setAdjustmentIsOpen(false)}
                    >
                        <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                        <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                    </svg>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add new adjustment</h2>
                                    </div>
                                </div>

                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <form onSubmit={handleSubmit}>
                                            <div className="grid grid-cols-2 gap-6">
                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Charge of Adjustment</label>
                                                        <Select
                                                            value={adjustmentOptions?.find(option => option.value === setSelectedAdjustment)}
                                                            options={adjustmentOptions}
                                                            onChange={(selectedOption) => setSelectedAdjustment(selectedOption ? selectedOption?.value : '')}
                                                            isSearchable
                                                            required
                                                            styles={{
                                                                control: (base, state) => ({
                                                                    ...base,
                                                                    backgroundColor: "transparent",
                                                                    color: themeStyles.form.inputTextColor,
                                                                    borderRadius: '6px',
                                                                    padding: '1px',
                                                                    borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    fontSize: "14px",
                                                                    backgroundColor: themeStyles.main.mainBg,
                                                                    color: themeStyles.form.inputTextColor,
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    backgroundColor: state.isSelected
                                                                        ? "#167AC3"
                                                                        : state.isFocused
                                                                            ? themeStyles.topBar.menuItemsHoverColor
                                                                            : "transparent",
                                                                    color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                                                    fontWeight: 600
                                                                }),
                                                                input: (base) => ({
                                                                    ...base,
                                                                    color: themeStyles.form.inputTextColor,

                                                                }),
                                                                singleValue: (base) => ({
                                                                    ...base,
                                                                    color: themeStyles.form.inputTextColor,
                                                                }),
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>{selectedChargeType} {" "} {selectionType === "Only One" ? " One Time" : "/ Day"}</label>
                                                        <input
                                                            type="text"
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={price}
                                                            required
                                                            onChange={(e) => setPrice(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="w-full mt-4">
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Comments</label>
                                                <textarea
                                                    className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    rows={6}
                                                    value={comment}
                                                    onChange={(e) => setComment(e.target.value)}
                                                />
                                            </div>

                                            <div className="flex gap-4 mt-6">
                                                <Button variant="contained"
                                                    sx={{
                                                        backgroundColor: colorConfigs.btn.main.bg
                                                    }}
                                                    type="submit"
                                                >
                                                    Save
                                                </Button>

                                                <Button variant="contained"
                                                    sx={{
                                                        backgroundColor: colorConfigs.btn.cancel.bg,
                                                        border: colorConfigs.btn.cancel.border,
                                                        color: colorConfigs.btn.cancel.color
                                                    }}
                                                    onClick={() => {
                                                        setAdjustmentIsOpen(false);
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default AddAdjustmentModal;